import React, { createContext, useContext, useReducer } from 'react';

// Initial state
const initialState = {
  currentScreen: 'connection', // 'connection', 'dashboard', 'addUser', 'query', 'mission', 'visualization'
  driver: null,
  userProfiles: {},
  selectedUser: null,
  isConnecting: false,
  isRefreshing: false,
  connectionStatus: null,
  chartInstance: null
};

// Action types
export const ActionTypes = {
  SET_SCREEN: 'SET_SCREEN',
  SET_DRIVER: 'SET_DRIVER',
  SET_USER_PROFILES: 'SET_USER_PROFILES',
  SET_SELECTED_USER: 'SET_SELECTED_USER',
  SET_CONNECTING: 'SET_CONNECTING',
  SET_REFRESHING: 'SET_REFRESHING',
  SET_CONNECTION_STATUS: 'SET_CONNECTION_STATUS',
  SET_CHART_INSTANCE: 'SET_CHART_INSTANCE',
  CLEAR_USER_PROFILES: 'CLEAR_USER_PROFILES'
};

// Reducer
function appReducer(state, action) {
  switch (action.type) {
    case ActionTypes.SET_SCREEN:
      return { ...state, currentScreen: action.payload };
    case ActionTypes.SET_DRIVER:
      return { ...state, driver: action.payload };
    case ActionTypes.SET_USER_PROFILES:
      return { ...state, userProfiles: action.payload };
    case ActionTypes.SET_SELECTED_USER:
      return { ...state, selectedUser: action.payload };
    case ActionTypes.SET_CONNECTING:
      return { ...state, isConnecting: action.payload };
    case ActionTypes.SET_REFRESHING:
      return { ...state, isRefreshing: action.payload };
    case ActionTypes.SET_CONNECTION_STATUS:
      return { ...state, connectionStatus: action.payload };
    case ActionTypes.SET_CHART_INSTANCE:
      return { ...state, chartInstance: action.payload };
    case ActionTypes.CLEAR_USER_PROFILES:
      return { ...state, userProfiles: {}, selectedUser: null };
    default:
      return state;
  }
}

// Context
const AppContext = createContext();

// Provider component
export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

// Custom hook to use the context
export function useApp() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}
